import { render, staticRenderFns } from "./CustomerBookings.vue?vue&type=template&id=2c11677a&scoped=true&"
import script from "./CustomerBookings.vue?vue&type=script&lang=ts&"
export * from "./CustomerBookings.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerBookings.vue?vue&type=style&index=0&id=2c11677a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c11677a",
  null
  
)

export default component.exports